import { useRouter } from 'next/router'
import { rem } from 'polished'
import React from 'react'
import { ROUTE } from 'shared-constants'
import styled from 'styled-components'
import { Button } from 'components/Button'
import { Box, Container, Flex } from 'components/Layout'
import { Text } from 'components/Typography'
import { COLOR_INTENT, FONT_STACK, FONT_WEIGHT, SPACE } from 'Theme'
import { PerksTable } from './PerksTable'
import { TierExplorer } from './TierExplorer'

const { TRADE_PAGE } = COLOR_INTENT.WIDGETS

const StatusCta = styled(Button)`
  background: ${TRADE_PAGE.CTA_BG};
  color: ${TRADE_PAGE.CTA_TEXT};

  &:hover {
    background: ${TRADE_PAGE.CTA_BG_HOVER};
  }
`

export const TradePerksSection: React.FC<{ isMember: boolean }> = ({
  isMember,
}) => {
  const router = useRouter()

  return (
    <Box position="relative">
      <Box
        position="absolute"
        top={{ MOBILE: '-94px', TABLET: '-60px' }}
        id="benefits"
      />
      <Box backgroundColor={TRADE_PAGE.SECTION_BG}>
        <Container
          pb={{ MOBILE: 0, TABLET: rem(84) }}
          px={{ MOBILE: SPACE.PX_24, TABLET: SPACE.PX_40 }}
        >
          <Text
            as="h2"
            fontFamily={FONT_STACK.SERIF}
            fontWeight={FONT_WEIGHT.NORMAL}
            fontSize={{ MOBILE: rem(28), TABLET: rem(34) }}
            color={TRADE_PAGE.HEADING}
            mb={SPACE.PX_6}
          >
            Get to know your perks
          </Text>
          <Flex
            alignItems="flex-start"
            justifyContent="space-between"
            flexWrap="wrap"
            gap={rem(24)}
            mb={{ MOBILE: SPACE.PX_24, TABLET: rem(26) }}
          >
            <Text
              fontSize={{ MOBILE: rem(14), TABLET: rem(15) }}
              lineHeight="1.6"
              color={TRADE_PAGE.TEXT_MUTED}
              display={{ MOBILE: 'none', TABLET: 'block' }}
              style={{ maxWidth: rem(560) }}
              mb={0}
            >
              Every benefit and the tier it becomes available.
            </Text>
            <Text
              fontSize={rem(14)}
              lineHeight="1.6"
              color={TRADE_PAGE.TEXT_MUTED}
              display={{ MOBILE: 'block', TABLET: 'none' }}
              mb={0}
            >
              Pick a tier to see everything it unlocks—and what&apos;s waiting
              at the next one.
            </Text>
            {isMember && (
              <StatusCta
                width="auto"
                onClick={() => {
                  router.push(`${ROUTE.EXPERT_DASHBOARD()}?tab=trade`)
                }}
              >
                Check your status
              </StatusCta>
            )}
          </Flex>

          <Box display={{ MOBILE: 'none', TABLET: 'block' }}>
            <PerksTable />
          </Box>
        </Container>

        <Box display={{ MOBILE: 'block', TABLET: 'none' }} pb={rem(60)}>
          <TierExplorer />
        </Box>
      </Box>
    </Box>
  )
}
